import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { enviarEventoGtm } from './gtm'

/**
 * Dispara um pageview ao GTM a cada troca de rota client-side.
 *
 * O GTM só é injetado uma vez no bootstrap (ver index.tsx); como é uma SPA
 * (React Router), navegações internas não recarregam a página e por isso
 * nunca geravam um novo evento de pageview — só as ~7 páginas com tracking
 * de conversão explícito acabavam "tageadas". Este hook cobre todas as rotas.
 */
export const useGtmPageview = (): void => {
  const location = useLocation()

  useEffect(() => {
    enviarEventoGtm({
      event: 'pageview',
      page: location.pathname + location.search
    })
  }, [location.pathname, location.search])
}
